module.exports = __webpack_public_path__ + "static/OP2-b6c96249250734ea4835fccab0e9e4e9.jpg";